<template>
  <div class="device-change-rule-item">
    <div class="content-wrap">
      <div class="aside">
        <div class="title">{{ title }}</div>
        <div class="info">
          <el-form ref="form" label-position="top">
            <el-form-item :label="$t('crm_device_change_rule_item.chan_pin_xing_hao')">
              <custom-select
                url="productCodeSelectList"
                width="223px"
                :props="{ label: 'productName', value: 'productCode' }"
                v-model="productCode"
                @change="onChangeDevice"
                :disabled="type === 'edit'"
              ></custom-select>
            </el-form-item>
            <el-form-item :label="$t('crm_device_change_rule_item.chan_pinSN')">
              <custom-select
                width="223px"
                :auto="false"
                :listener="productCode"
                v-model="productSnArr"
                url="productSnList"
                multiple
                :params="{ productCodes: productCode ? [productCode] : [] }"
                :props="{ label: 'productSn', value: 'productSn' }"
                :placeholder="$t('Common.com_please_select')"
                style="width: 100%"
                :disabled="!productCode || type === 'edit'"
                @change="onChangeDevice('sn')"
              ></custom-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="content">
        <div class="title">{{ $t('crm_device_change_rule_item.gui_ze_xiang_qing') }}</div>
        <ul>
          <li v-for="(ruleItem, index) in ruleList" :key="index">
            <div class="tit">{{ ruleItem.deviceBizType }}</div>
            <div class="sub" v-html="ruleText(ruleItem)"></div>
            <div class="list" v-for="(rule, idx) in ruleItem.children" :key="idx">
              <div class="and-type ub">
                <div class="ub-f1">
                  <el-radio-group v-model="rule.ruleConditionObj.connectSymbol" style="margin-left: 18px">
                    <el-radio :label="0">{{ $t('crm_device_change_rule_item.ren_yi_tiao_jian') }}</el-radio>
                    <el-radio :label="1">{{ $t('crm_device_change_rule_item.suo_you_tiao_jian') }}</el-radio>
                  </el-radio-group>
                </div>
                <div v-if="idx > 0" class="icon-box" style="line-height: 50px; margin-right: 10px" @click="delRule(ruleItem.children, idx)">
                  <i class="icon icon-shanchu"></i>
                </div>
              </div>
              <div class="and-rule">
                <div class="rule-item ub" v-for="(items, i) in rule.ruleConditionObj.children" :key="i">
                  <el-row :gutter="10" class="ub-f1">
                    <el-col :span="6">
                      <custom-select v-model="items.type" code="dms_device_biz_type_condition" :placeholder="$t('Common.com_please_select')" width="100%" @change="setTypeName($event, items)"></custom-select>
                    </el-col>
                    <el-col :span="6">
                      <custom-select v-model="items.symbol" code="isynergy_cloud_symbol" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
                    </el-col>
                    <el-col :span="12">
                      <el-input type="number" v-model="items.value" :placeholder="$t('Common.com_please_input')" style="width: 100%"></el-input>
                    </el-col>
                  </el-row>
                  <div v-if="i > 0" class="icon-box" @click="delSymbol(rule.ruleConditionObj.children, i)">
                    <i class="icon icon-shanchu"></i>
                  </div>
                  <div v-else class="icon-box" style="opacity: 0">
                    <i class="icon icon-shanchu"></i>
                  </div>
                </div>
                <div class="add-child-btn" @click="addSymbol(rule.ruleConditionObj.children)">
                  <div style="display: inline-block">
                    <i class="icon icon-add"></i>
                    <span>{{ $t('crm_device_change_rule_item.tjtjfw') }}</span>
                  </div>
                </div>
                <div style="margin-top: 8px">
                  <el-table :data="rule.toDeviceList" style="width: 100%">
                    <el-table-column label="#" type="index" width="40"></el-table-column>
                    <el-table-column :label="$t('crm_device_change_rule_item.chan_pin_xing_hao')" width="120">
                      <template slot-scope="scope">
                        <custom-select
                          url="productCodeSelectList"
                          width="100px"
                          :props="{ label: 'productName', value: 'productCode' }"
                          v-model="scope.row.toProductCode"
                          @change="onChangeProduct($event, scope.row)"
                        ></custom-select>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('crm_device_change_rule_item.chan_pinSN')" width="200">
                      <template slot-scope="scope">
                        <custom-select
                          width="180px"
                          :listener="scope.row.toProductCode"
                          v-model="scope.row.toProductCodeSnArr"
                          url="productSnList"
                          multiple
                          :params="{ productCodes: scope.row.toProductCode ? [scope.row.toProductCode] : [] }"
                          :props="{ label: 'productSn', value: 'productSn' }"
                          :placeholder="$t('Common.com_please_select')"
                          style="width: 100%"
                          :disabled="!scope.row.toProductCode"
                        ></custom-select>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('crm_device_change_rule_item.she_bei_lei_xing')">
                      <template slot-scope="scope">
                        <el-checkbox-group v-model="scope.row.toDeviceBizTypes">
                          <el-checkbox :key="idx" v-for="(item, idx) in dmsDeviceBizType" :label="item.value"></el-checkbox>
                        </el-checkbox-group>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('Common.com_handle')" width="100">
                      <template slot-scope="scope">
                        <el-button size="mini" type="text" v-if="scope.$index > 0" @click="delDevice(rule.toDeviceList, scope.$index)">{{ $t('Common.com_delete') }}</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="add-child-btn" style="background-color: #f2f3fb" @click="addDevice(rule.toDeviceList)">
                    <div style="display: inline-block">
                      <i class="icon icon-add"></i>
                      <span>{{ $t('crm_device_change_rule_item.xzkghcpxhsblx') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="role-add-btn" @click="addRule(ruleItem.children)" style="margin-bottom: 12px">
              <div style="display: inline-block">
                <i class="icon icon-add"></i>
                <span>{{ $t('crm_device_change_rule_item.tian_jia_tiao_jian') }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="btn-group">
      <div class="btn" @click="jump(-1)">{{ $t('Common.com_cancel') }}</div>
      <div class="btn ok" @click="save">{{ saveText }}</div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis.js';

export default {
  name: 'device_change_rule_item',
  data() {
    return {
      // 页面类型，add, edit, copy
      type: 'add',
      ruleList: [],
      productCode: '',
      productSnArr: [],
      dmsDeviceBizType: [],
      disabledListen: true,
    };
  },
  computed: {
    title() {
      const TITLE = {
        ADD: this.$t('crm_device_change_rule_item.xzsbghgz'),
        EDIT: this.$t('crm_device_change_rule_item.bjsbghgz'),
      };
      let ret = '';
      switch (this.type) {
        case 'add':
          ret = TITLE.ADD;
          break;
        case 'edit':
          ret = TITLE.EDIT;
          break;
        default:
          ret = TITLE.ADD;
          break;
      }
      return ret;
    },
    saveText() {
      return this.type === 'add' ? this.$t('Common.com_add') : this.$t('Common.com_save');
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    onChangeProduct: function (item, row) {
      if (this.disabledListen) {
        return;
      }
      row.toProductCodeSnArr = [];
    },
    arrayGroupBy: function (arr, iteratee) {
      const list = [];
      for (const item of arr) {
        const key = typeof iteratee === 'function' ? iteratee(item) : item[iteratee];
        const index = list.findIndex((t) => t.key === key);
        if (index === -1) {
          list.push({ key: key, value: [item] });
        } else {
          list[index].value.push(item);
        }
      }
      return list.map((t) => t.value);
    },
    init() {
      this.type = this.getJump('type');
      this.productCode = this.getJump('productCode');
      const sns = this.getJump('productSns') || '';
      this.productSnArr = sns ? sns.split(',') : [];
      this.getDictionary('dms_device_biz_type,crm_sharing_rule_condition_type,dms_device_biz_type_condition', (data) => {
        this.dmsDeviceBizType = data.dms_device_biz_type;
        this.ruleList = this.parseRuleList([]);
        if (this.type === 'edit') {
          this.onChangeDevice();
        }
      });
    },
    onChangeDevice: function (code) {
      if (this.productCode) {
        this.disabledListen = true;
        this.$getJSON(apis.deviceChangeRuleInfo, { productCode: this.productCode, productSns: this.productSnArr.join(',') }).then((res) => {
          this.ruleList = this.parseRuleList(res.data || []);
          setTimeout(() => {
            this.$nextTick(() => {
              this.disabledListen = false;
            });
          }, 1500);
        });
      }
      if (code !== 'sn' && this.type !== 'edit') {
        this.productSnArr = [];
      }
    },
    // 解析ruleCondition
    parseRuleCondition(ruleCondition) {
      if (!ruleCondition) {
        return {
          connectSymbol: 0,
          children: [
            {
              type: '',
              typeName: '',
              symbol: '',
              value: '',
            },
          ],
        };
      }
      return {
        connectSymbol: ruleCondition.includes('&') ? 1 : 0,
        children: ruleCondition
          .replace('(', '')
          .replace(')', '')
          .split(/&|\|\|/)
          .map((c) => {
            const conditionArr = c.trim().split(' ');
            const type = conditionArr[0];
            const symbol = conditionArr[1];
            const value = conditionArr[2];
            const typeName = this.valueToName(type);
            return {
              type,
              typeName,
              symbol,
              value,
            };
          }),
      };
    },
    // 解析规则
    parseRuleList(list) {
      return this.dmsDeviceBizType.map((item) => {
        const bizTypeGroup = list.filter((val) => val.deviceBizType === item.value);
        if (bizTypeGroup.length > 0) {
          const conditionGroup = this.arrayGroupBy(bizTypeGroup, (t) => `${t.ruleCondition}`);
          return {
            deviceBizType: item.value,
            children: conditionGroup.map((arr) => ({
              ruleCondition: arr[0].ruleCondition, // 规则条件
              ruleConditionObj: this.parseRuleCondition(arr[0].ruleCondition), // 规则条件对象
              toDeviceList: arr.map((t) => ({
                ruleId: t.ruleId,
                toProductCode: t.toProductCode,
                toProductCodeSnArr: t.toProductSns ? t.toProductSns.split(',') : [],
                toDeviceBizTypes: t.toDeviceBizTypes.split(','),
              })),
            })),
          };
        }
        return {
          deviceBizType: item.value,
          children: [
            {
              ruleCondition: '', // 规则条件
              ruleConditionObj: this.parseRuleCondition(''), // 规则条件对象
              toDeviceList: [{ ruleId: null, toProductCode: this.productCode, toProductCodeSnArr: [], toDeviceBizTypes: [] }],
            },
          ],
        };
      });
    },
    // 字典值转换
    valueToName(value) {
      const item = this.propertyMap.dms_device_biz_type_condition.find((obj) => `${obj.value}` === `${value}`);
      return item && item.name;
    },
    addDevice: function (item) {
      item.push({ ruleId: null, toProductCode: '', toProductCodeSnArr: [], toDeviceBizTypes: [] });
    },
    addSymbol: function (item) {
      item.push({
        type: '',
        typeName: '',
        symbol: '',
        value: '',
      });
    },
    delSymbol: function (item, index) {
      item.splice(index, 1);
    },
    delDevice: function (item, index) {
      item.splice(index, 1);
    },
    addRule: function (rules) {
      rules.push({
        ruleCondition: '', // 规则条件
        ruleConditionObj: this.parseRuleCondition(''), // 规则条件对象
        toDeviceList: [{ ruleId: null, toProductCode: '', toProductCodeSnArr: [], toDeviceBizTypes: [] }],
      });
    },
    delRule: function (item, index) {
      item.splice(index, 1);
    },
    ruleText: function (data) {
      const ruleText = [];
      data.children.forEach((item) => {
        const list = item.ruleConditionObj.children.filter((t) => t.typeName && t.symbol && t.value);
        const row = list.map((t) => `${t.typeName} ${t.symbol} ${t.value}`);
        const tip = row.join(item.ruleConditionObj.connectSymbol ? ' & ' : ' || ');
        const row1 = list.map((t) => `${t.type} ${t.symbol} ${t.value}`);
        item.ruleCondition = row1.length > 0 ? `(${row1.join(item.ruleConditionObj.connectSymbol ? ' & ' : ' || ')})` : '';
        if (tip) {
          ruleText.push(`(${tip})`);
        }
        // 标识规则是否填写完整
        const ruleIsComplete = item.ruleConditionObj.children.filter((t) => !((t.type && t.symbol && t.value) || (!t.type && !t.symbol && !t.value))).length === 0;
        const deviceIsComplete = list.length > 0 ? item.toDeviceList.filter((t) => t.toProductCode && t.toDeviceBizTypes.length).length > 0 : true;
        this.$set(item, 'isComplete', ruleIsComplete && deviceIsComplete);
      });
      return ruleText.join('<p>OR</p>') || this.$t('crm_device_change_rule_item.qtxgztj');
    },
    setTypeName: function (obj, item) {
      item.typeName = obj ? obj.name : '';
    },
    validate(cb) {
      if (!this.productCode) {
        this.$message.error(this.$t('crm_device_change_rule_item.qxzcpxh'));
        cb(false);
        return;
      }
      const isComplete = this.ruleList.reduce((per, item) => [...per, ...item.children], []).filter((t) => !t.isComplete).length === 0;
      if (!isComplete) {
        this.$message.error(this.$t('crm_device_change_rule_item.qjgztxwc'));
        cb(false);
        return;
      }
      cb(true);
    },
    getReqData() {
      const reqData = [];
      this.ruleList.forEach((item) => {
        const deviceBizType = item.deviceBizType;
        item.children.forEach((val) => {
          const ruleCondition = val.ruleCondition;
          val.toDeviceList.forEach((device) => {
            reqData.push({
              productCode: this.productCode,
              productSns: this.productSnArr.join(','),
              ruleId: device.ruleId,
              toProductCode: device.toProductCode,
              toProductSns: device.toProductCodeSnArr.join(','),
              toDeviceBizTypes: device.toDeviceBizTypes.join(','),
              ruleCondition,
              deviceBizType,
            });
          });
        });
      });
      return reqData.filter((t) => t.toDeviceBizTypes && t.toProductCode);
    },
    save() {
      if (this.type === 'add') {
        this.create();
      }
      if (this.type === 'edit') {
        this.edit();
      }
    },
    // 新增
    create() {
      this.validate((validate) => {
        if (validate) {
          const list = this.getReqData();
          if (list.length === 0) {
            this.$message.error(this.$t('crm_device_change_rule_item.qjgztxwc'));
            return;
          }
          this.clearKeepAlive('deviceChangeRule');
          this.$postJSON(apis.deviceChangeRuleSave, this.getReqData(), true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_add_success'),
            });
            this.clearTagByKeep('device_change_rule_item');
            this.jump('/offer/deviceChangeRule', {}, true);
          });
        }
      });
    },
    // 编辑
    edit() {
      this.validate((validate) => {
        if (validate) {
          this.clearKeepAlive('deviceChangeRule');
          this.$postJSON(apis.deviceChangeRuleSave, this.getReqData('edit'), true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_edit_success'),
            });
            this.clearTagByKeep('device_change_rule_item');

            this.jump('/offer/deviceChangeRule', {}, true);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'style/colors.scss';

.device-change-rule-item {
  background-color: #ffffff;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 80px;
  .btn-group {
    height: 80px;
    text-align: center;
    background-color: #f2f2f2;
    padding-top: 20px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    .btn {
      cursor: pointer;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
      width: 110px;
      background-color: #ffffff;
      color: #1e1e1e;
      font-size: 14px;
      &.ok {
        margin-left: 10px;
        background-color: #00afff;
        color: #ffffff;
      }
    }
  }
  .content-wrap {
    width: 1100px;
    margin: 0 auto;
    display: flex;
    .title {
      color: #262626;
      font-size: 16px;
      padding: 20px 0;
    }

    .aside {
      width: 242px;
      border-right: 1px solid #e4e4e4;
      .el-form-item--small.el-form-item {
        margin-bottom: 8px;
      }
    }
    .content {
      flex: 1;
      width: 0;
      padding: 0 0 56px 20px;
      .role-add-btn {
        background: rgba(245, 245, 245, 1);
        border: 1px solid rgba(228, 228, 228, 1);
        line-height: 40px;
        text-align: center;
        color: #333333;
        font-size: 12px;
        margin-top: 10px;
        cursor: pointer;
        .icon {
          color: #00afff;
          font-size: 10px;
          margin-right: 8px;
          float: left;
        }
      }
      ul li {
        border: 1px solid rgba(228, 228, 228, 1);
        position: relative;
        margin-top: 24px;
        padding: 24px 30px;
        .tit {
          width: 42px;
          text-align: center;
          background-color: #ffffff;
          position: absolute;
          line-height: 45px;
          color: #00afff;
          font-size: 32px;
          font-weight: bold;
          top: -23px;
          left: 20px;
        }
        .sub {
          color: #818181;
          font-size: 12px;
          line-height: 30px;
          margin-bottom: 25px;
        }
        .list {
          border: 1px solid rgba(228, 228, 228, 1);
          margin-bottom: 10px;
          .and-type {
            background-color: #f5f5f5;
            line-height: 50px;
            border-bottom: 1px solid rgba(228, 228, 228, 1);
          }
          .and-rule {
            padding: 14px 10px;
          }
        }
        .rule-item {
          margin-bottom: 5px;
        }
        .icon-box {
          line-height: 30px;
          width: 30px;
          margin-left: 10px;
          text-align: center;
          .icon {
            color: #00afff;
            font-size: 14px;
            cursor: pointer;
          }
        }
        .add-child-btn {
          background: rgba(245, 245, 245, 1);
          border: 1px dashed rgba(228, 228, 228, 1);
          line-height: 30px;
          text-align: center;
          color: #333333;
          font-size: 12px;
          margin-top: 10px;
          cursor: pointer;
          .icon {
            color: #00afff;
            font-size: 10px;
            margin-right: 8px;
            float: left;
          }
        }
      }
    }
  }
}
</style>
